class Press {
  constructor() {
    this.$showAllBtn = document.querySelector('.js-press-showall-btn')
    if (!this.$showAllBtn) return
    this.$press = document.querySelector('.js-press')
    this.$showAllBtn.addEventListener('click', this.showAll.bind(this))
  }

  showAll(event) {
    event.preventDefault()
    let $hiddenItems = this.$press.querySelectorAll('.js-press-item.u-hidden')
    for (let i = 0; i < $hiddenItems.length; i++) {
      $hiddenItems[i].classList.remove('u-hidden')
    }

    this.$showAllBtn.parentNode.parentNode.removeChild(this.$showAllBtn.parentNode)
  }
}

export default new Press()
